module.exports = __webpack_public_path__ + "media/images/business/i-point-340143e5f2999b9f630c25f1acb576f1.svg";